import { onReady } from './utils/on-ready';

export class ApProfileCard {
    constructor() {
        onReady(this.initialize);
    }

    initialize = () => {
        // This will be revisited at a later date for the horizontal scroll.
        // const scrollContainer = document.querySelector(".ap-card-scroll__wrapper__scroll");
        // scrollContainer.addEventListener("wheel", (e) => {
        //   e.preventDefault();
        //   scrollContainer.scrollLeft += (e as WheelEvent).deltaY;
        // });
    }

    showProfileDialog = (staffId: any): void => {
        // Instead of "MDCDialog.attachTo(...)", we grab the <md-dialog> element directly.
        const dialogEl = document.querySelector('.staff-dialog-' + staffId) as HTMLDialogElement | null;
        if (dialogEl && 'showModal' in dialogEl) {
            // .showModal() displays the dialog as a modal. 
            dialogEl.showModal();
        }
    };
}
